import { render, staticRenderFns } from "./AttachmentRequirement.vue?vue&type=template&id=3a83e877"
import script from "./AttachmentRequirement.vue?vue&type=script&lang=js"
export * from "./AttachmentRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports